export default "__VITE_PUBLIC_ASSET__8965e372__"